export default __webpack_public_path__ + "static/media/pencilIcon.a79e6fee.svg";